<template>
    <div class="question-print-view-warning text-dark">
        <font-awesome-icon :icon="['fad', 'info-circle']" class="mr-2 h1" />
        <div>
            <div class="h6 mb-1">{{ warning_title }}</div>
            <div class="small">{{ warning_text }}</div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        warning_title: {
            type: String,
            default: "Print and Online versions don't match",
        },
        warning_text: {
            type: String,
            default: 'Review both versions to ensure consistency.',
        },
    },
}
</script>

<style lang="scss" scoped>
.question-print-view-warning {
    display: flex;
    align-items: flex-start;
    margin-bottom: 0.75rem;
    padding: 0.75rem 1.25rem;
    background-color: rgba(132, 94, 11, 0.08);
    border-bottom: 1px solid #845e0b;
    font-weight: 600;
}
</style>
